import React from 'react';
// import { SocialData } from '../../data/social';
import "./SocialContact.css"


const SocialContact = () => {


    return (
        <div className="social-contact">
            <div className="social-icon-div">
                <a href="https://www.linkedin.com/in/pranitingole/"><i className="fab fa-linkedin-in thisicon"></i></a>
                <a href="https://github.com/pranitcode"><i className="fab fa-github thisicon"></i></a>
                <a href="https://www.instagram.com/pranit.ingole/"><i className="fab fa-instagram thisicon"></i></a>
                <a href="https://twitter.com/PranitIngole"><i className="fab fa-twitter thisicon"></i></a>
            </div>
           
        </div>
    );
}

export default SocialContact;


